import React from 'react';
import { reactLocalStorage } from 'reactjs-localstorage';
import { Form, Button, Row, Col } from 'react-bootstrap';
import Const from '../../util/Constants';
import withRouter from '../../util/WithRouter';
import FieldText from '../common/FieldText';
import ApiUiController from '../../controller/ApiUiController';
import ValidationController from '../../controller/ValidationController';
import EmailTemplateAPI from '../../api/EmailTemplateAPI';
import Util from '../../util/Util';

import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';

class EmailTemplateUpdate extends React.Component {
  constructor(props) {
    super(props);
    this.id = parseInt(props.match.params.id);
    this.model = reactLocalStorage.getObject(Const.Model).email_temp;
    this.state = {
      inApiCall: this.id !== 0,
      email: {
        id: 0,
        name: '',
        subject: '',
        txt_body_html: '',
      },
      inValid: {},
      isHtmlMode: false,
    };
    this.base = this.props.match.path;
    this.base = this.base.substring(0, this.base.indexOf('/add-edit'));
  }

  componentDidMount() {
    if (this.id !== 0) {
      EmailTemplateAPI.get(this.id, this.onReceived, this.onFail);
    }
  }

  onReceived = (email) => {
    if (!email.txt_body_html) email.txt_body_html = '';
    this.setState({ email, inApiCall: false }, this.updatePreview);
  };

  onFail = () => {
    this.setState({ inApiCall: false });
  };

  onValueChange = (field, text) => {
    const email = { ...this.state.email, [field]: text };
    this.setState({ email, inValid: {} }, () => {
      if (field === 'txt_body_html') {
        this.updatePreview();
      }
    });
  };

  onSave = () => {
    const { email } = this.state;
    const inValid = ValidationController.validate(this.model.fields, email);
    if (inValid === null) {
      this.setState({ inApiCall: true });
      EmailTemplateAPI.save(email, this.onSaved, this.onFail);
    } else {
      this.setState({ inValid });
    }
  };

  onSaved = () => {
    Util.showNotification('Successful', 'Template successfully saved', 'success');
    this.props.navigate(this.base);
  };

  toggleHtmlMode = () => {
    this.setState((prevState) => ({ isHtmlMode: !prevState.isHtmlMode }), () => {
      if (!this.state.isHtmlMode) {
        setTimeout(this.updatePreview, 100);
      }
    });
  };

  updatePreview = () => {
    const iframe = document.getElementById('htmlPreview');
    if (iframe) {
      const doc = iframe.contentDocument || iframe.contentWindow.document;
      const html = this.state.email.txt_body_html || '';
      doc.open();
      doc.write(`<!DOCTYPE html><html><head><meta charset="utf-8"></head><body>${html}</body></html>`);
      doc.close();
    }
  };

  render() {
    const { email, inValid, isHtmlMode, inApiCall } = this.state;

    return (
      <div className="sectionform pt-4">
        <div className="mb-4 px-3 py-2">
          <h3 className="mb-0">
            {this.id === 0 ? 'Add Email Template' : 'Edit Email Template'}
          </h3>
          <hr />
        </div>

        <div className="container-fluid form-cont">
          <ApiUiController inApiCall={inApiCall}>
            <Form className="lead-form">
              <Row>
                {/* Left Side: Form + Editor */}
                <Col md={6}>
                  <FieldText
                    key="name"
                    id="name"
                    field={this.model.fields.name}
                    value={email.name}
                    onValueChange={this.onValueChange}
                    inValid={inValid}
                  />
                  <FieldText
                    key="subject"
                    id="subject"
                    field={this.model.fields.subject}
                    value={email.subject}
                    onValueChange={this.onValueChange}
                    inValid={inValid}
                  />

                  <div className="d-flex justify-content-between align-items-center mt-4 mb-2 px-3">
                    <h6 className="mb-0">Email Body</h6>
                    <Form.Check
                      type="switch"
                      id="html-switch"
                      label={isHtmlMode ? 'HTML Source' : 'Visual Editor'}
                      checked={isHtmlMode}
                      onChange={this.toggleHtmlMode}
                    />
                  </div>

                  <div className='px-3'>
                    {isHtmlMode ? (
                      <>
                        <Form.Control
                          as="textarea"
                          rows={15}
                          value={email.txt_body_html}
                          onChange={(e) => this.onValueChange('txt_body_html', e.target.value)}
                        />
                        <div className="text-danger small mt-2">
                          You are editing raw HTML. Ensure tags are valid.
                        </div>
                      </>
                    ) : (
                      <CKEditor
                        editor={ClassicEditor}
                        data={email.txt_body_html || ''}
                        onChange={(event, editor) => {
                          const data = editor.getData();
                          this.onValueChange('txt_body_html', data);
                        }}
                      />
                    )}
                  </div>

                  <div className="text-center pt-4">
                <Button variant="success" onClick={this.onSave} disabled={inApiCall}>
  {this.id === 0 ? 'Save Template' : 'Update Template'}
</Button>
                  </div>
                </Col>

                {/* Right Side: Live Preview */}
                <Col md={6}>
                  <div className="border p-3 rounded bg-light">
                    <h6 className="mb-3">Live Preview</h6>
                    <iframe
                      id="htmlPreview"
                      style={{ width: '100%', height: '500px', border: '1px solid #ccc' }}
                      title="HTML Preview"
                    />
                  </div>
                </Col>
              </Row>
            </Form>
          </ApiUiController>
        </div>
      </div>
    );
  }
}

export default withRouter(EmailTemplateUpdate);
